import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This is a component that returns the translated label for different access levels
 * @param {number} props.level - The number of the access level
 */

function AccessLevelsLabels(props) {
  const level = props.level;

  switch (level) {
    case 0:
      return (
        <span data-test="level-0">
          <FormattedMessage
            id="accessLevelsLabels.readOnly"
            defaultMessage="Read Only"
            description="Read Only"
          />
        </span>
      );

    case 1:
      return (
        <span data-test="level-1">
          <FormattedMessage
            id="accessLevelsLabels.basicAccess"
            defaultMessage="Basic Access"
            description="Basic Access"
          />
        </span>
      );

    case 4:
      return (
        <span data-test="level-4">
          <FormattedMessage
            id="accessLevelsLabels.reports"
            defaultMessage="Reports"
            description="Reports"
          />
        </span>
      );

    case 6:
      return (
        <span data-test="level-6">
          <FormattedMessage
            id="accessLevelsLabels.deviceAdministration"
            defaultMessage="Device Administration"
            description="Device Administration"
          />
        </span>
      );

    case 8:
      return (
        <span data-test="level-8">
          <FormattedMessage
            id="accessLevelsLabels.systemAdministration"
            defaultMessage="System Administration"
            description="System Administration"
          />
        </span>
      );
    case 10:
      return (
        <span data-test="level-10">
          <FormattedMessage
            id="accessLevelsLabels.userAdministration"
            defaultMessage="User Administration"
            description="User Administration"
          />
        </span>
      );

    default:
      break;
  }
}

export default AccessLevelsLabels;
